import axios from 'axios';

export default {

  fetchCategories: async ({ commit, state }) => {
    try {
      const response = await axios.get(`${state.currentLocale.href}api/categories/all/`);
      commit('setCategories', { categories: response.data });
    } catch (err) {
      commit('setCategories', { categories: [] });
      console.log(err);
    }
  },

  fetchShop: async ({ commit, state }, { slug }) => {
    try {
      const response = await axios.get(`${state.currentLocale.href}api/shops/${slug}/`);
      commit('setShop', { shop: response.data });
    } catch (err) {
      commit('setShop', { shop: {} });
      console.log(err);
    }
  },

  fetchShopCoupons: async ({ commit, state }, { shop, type = 'all', limit = 15, offset = 0, reload = true }) => {
    try {
      const response = await axios.get(`${state.currentLocale.href}api/coupons/get/`, {
        params: { shop, type, limit, offset }
      });
      if (reload) {
        if (type !== 'expired') {
          let data = { shopCoupons: response.data.total_coupons, shopCouponsCount: response.data.count };
          if (response.data.filtersCount) {
            data = { ...data, shopFiltersCount: response.data.filtersCount };
          }
          commit('setShopCoupons', data);
        } else {
          commit('setShopCouponsExpired', { shopCouponsExpired: response.data.total_coupons });
        }
      } else {
        commit('pushShopCoupons', { shopCoupons: response.data.total_coupons })
      }
    } catch (err) {
      commit('setShopCoupons', { shopCoupons: [], shopCouponsCount: 0, shopFiltersCount: {} });
      console.log(err);
    }
  },

  fetchShopCoupon: async ({ commit, state }, { couponId }) => {
    try {
      const response = await axios.get(`${state.currentLocale.href}api/coupons/get/${couponId}/`);
      commit('setShopCoupon', { shopCoupon: response.data });
    } catch (err) {
      commit('setShopCoupon', { shopCoupon: {} });
      console.log(err);
    }
  },

  fetchPopularShop: async ({ commit, state }, { shopSlug }) => {
    try {
      const response = await axios.get(`${state.currentLocale.href}api/shops/same_category/${shopSlug}/`);
      commit('setPopularShops', { shop: response.data });
    } catch (err) {
      commit('setPopularShops', {});
      console.log(err);
    }
  }

}